export default
{
    html: null,
    title: "",
    primaryColor: "#27283f",
    secondaryColor: "#EB4041",
    tertiaryColor: "#cccccc",
    logoImageUrl: _PUBLIC_PATH + '/images/news-personalizada/logo.png',
    bannerSection: {
        image: {
            url: _PUBLIC_PATH + '/images/news-personalizada/banner.png',
            alt: "Imagem com produtos Atlas Powertech",
        },
    },
    descriptionSection: {
        title: "Linha de Máquinas Atlas Powetech",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec interdum rutrum nunc, id faucibus erat ultrices in. In tellus enim, efficitur eu blandit et, tempus vitae justo. Ut a velit orci.",
        button: {
            text: "Clique aqui e saiba mais",
            link: "https://www.pinceisatlas.com.br",
        }
    },
    productsListSection: {
        title: "Conheça nossa linha completa de máquinas",
        productsList: [
            {
                id: 1,
                isOpen: false,
                image: {
                    url: _PUBLIC_PATH + "/images/news-personalizada/img-produto.png",
                    alt: "Imagem do produto"
                },
                productData: {
                    name: "Lixadeira Roto-Orbital",
                    code: "AT1701",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec interdum rutrum nunc, id faucibus erat ultrices in.",
                    link: {
                        text: "Saiba +",
                        url: "http://www.google.com"
                    }
                }
            }
        ],
    },
    selectedSection: "",
}
